import React from 'react'
import ChartConfig from '../../Device/ChartConfig';
import DeviceModal from '../DeviceModal'
import './index.css'

export default function ConfigModal({ travel, device, deviceData, status, onSaveModalForm }) {

  switch (status) {
    case 'graph':
      return (
        <DeviceModal device={device} deviceData={deviceData} />
      )
    case 'settings':
      return (
        <ChartConfig device={device} travel={travel} onSaveModalForm={onSaveModalForm}/>
      )
    default:
      break;
  }
}